import React, { useState } from 'react'
import {
  mdiMenuUp,
  mdiMenuDown,
  mdiWeight,
  mdiTapeMeasure,
  mdiArrowExpandAll,
  mdiBinoculars,
  mdiCheck,
  mdiClose,
  mdiTruckFast,
  mdiPackageUp,
  mdiAlarm,
} from '@mdi/js'
import t from '../functions/t'
import getCarrierData from '../functions/getCarrierData'
import { Card, Col, Icon, Justify, Row, Error } from './standard'

export default function Result({
  rate = 0,
  country = '',
  info = {},
  openDefault = false,
  lineIndex = 0,
}) {
  const [open, setOpen] = useState(openDefault)

  if (!Object.keys(info).length) return <Error message='No info given' />

  return (
    <Card
      style={{ opacity: rate === 0 ? 0.5 : 1 }}
      className={lineIndex == 0 && 'mt-0'}
      headerClassName={open ? 'border-bottom' : 'border-bottom-0'}
      header={
        <div onClick={() => setOpen(!open)} style={{ cursor: 'pointer' }}>
          <div className='row'>
            <div className='col-12 col-md-9 col-lg-10'>
              <div className='row d-flex justify-content-between'>
                <div className='col-12 col-lg-auto d-flex align-items-center gap-2'>
                  <div
                    data-carrier={info.company}
                    style={{
                      display: 'inline-block',
                      height: '1.2em',
                      lineHeight: '0.9em',
                      width: '3em',
                    }}
                  >
                    {getCarrierData(info.company).logo()}
                  </div>
                  <b>{info.name}</b>
                </div>
                <div className='col-12 col-lg-auto d-none d-md-block'>
                  <span
                    className={
                      info.recommended ? 'text-success' : 'text-secondary'
                    }
                  >
                    {info.deliveryDays}
                  </span>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-3 col-lg-2'>
              <div className='row d-flex justify-content-between justify-content-md-end'>
                <div className='col-auto d-block d-md-none'>
                  <span
                    className={
                      info.recommended ? 'text-success' : 'text-secondary'
                    }
                  >
                    {info.deliveryDays}
                  </span>
                </div>
                <div className='col-auto'>
                  <div className='d-inline-block'>
                    <b>${rate === 0 ? '—' : rate.toFixed(2)}</b>
                  </div>
                  <div className='d-inline-block'>
                    {open ? (
                      <Icon large bare path={mdiMenuUp} className='align-top' />
                    ) : (
                      <Icon
                        large
                        bare
                        path={mdiMenuDown}
                        className='align-top'
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      body={
        open && (
          <div>
            <p>{info.paragraph}</p>
            {info.requiresDutiesInAdvance && (
              <p>{t('warnings.requires_duties_in_advance')}</p>
            )}
            <hr />
            <Row>
              <Col md={7} className='fw-bold'>
                <Icon path={mdiAlarm} />
                <span className='align-middle'>
                  {t('shipping_methods.delivery_time')}
                </span>
              </Col>
              <Col md={5} className='text-md-end'>
                <span>{info.deliveryDays}</span>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col md={5} className='fw-bold'>
                <Icon path={mdiWeight} />
                <span className='align-middle'>
                  {t('shipping_methods.max_weight')}
                </span>
              </Col>
              <Col md={7} className='text-md-end'>
                <span>{info.maxWeight}</span>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col md={7} className='fw-bold'>
                <Icon path={mdiTapeMeasure} />
                <span className='align-middle'>
                  {t('shipping_methods.dimensional_weight')}
                </span>
              </Col>
              <Col md={5} className='text-md-end'>
                <span>{info.dimensionalWeight}</span>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col md={5} className='fw-bold'>
                <Icon path={mdiArrowExpandAll} />
                <span className='align-middle'>
                  {t('shipping_methods.max_size')}
                </span>
              </Col>
              <Col md={7} className='text-md-end'>
                <span style={{ whiteSpace: 'pre-line' }}>{info.maxSize}</span>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col md={7} className='fw-bold'>
                <Icon path={mdiBinoculars} />
                <span className='align-middle'>
                  {t('shipping_methods.tracking')}
                </span>
              </Col>
              <Col md={5} className='text-md-end'>
                {info.tracking === 'true' ? (
                  <Icon path={mdiCheck} className='text-success' />
                ) : info.tracking === 'false' ? (
                  <Icon path={mdiClose} className='text-danger' />
                ) : (
                  <span>{info.tracking}</span>
                )}
              </Col>
            </Row>
            <hr />
            <Row>
              <Col md={7} className='fw-bold'>
                <Icon path={mdiTruckFast} />
                <span className='align-middle'>
                  {t('shipping_methods.freq_dep')}
                </span>
              </Col>
              <Col md={5} className='text-md-end'>
                <span>{info.freqDep}</span>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col md={4} className='fw-bold'>
                <Icon path={mdiPackageUp} />
                <span className='align-middle'>
                  {t('shipping_methods.insurance')}
                </span>
              </Col>
              <Col md={8} className='text-md-end'>
                <span>
                  {info.insurance}
                  <br />
                  {info.insurable && (
                    <span>
                      {t('shipping_methods.insurance_print').replace(
                        '%{country}',
                        country
                      )}
                    </span>
                  )}
                </span>
              </Col>
            </Row>
          </div>
        )
      }
    />
  )
}
